import React, { useState, useEffect } from 'react';

export default function MTDStatusBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('mtd_banner_dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const hide = () => {
      setIsLeaving(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsLeaving(false);
      }, 300);
    };

    // Watch for the "How it works" section entering the viewport.
    // Falls back to a pixel threshold if the element isn't present on this page.
    const target = document.getElementById('how-it-works');

    if (target) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            hide();
            observer.disconnect();
          }
        },
        // Fire once the top of the section has scrolled 10% into view
        { threshold: 0.1 }
      );
      observer.observe(target);
      return () => observer.disconnect();
    }
  }, [isVisible]);

  const handleDismiss = () => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsLeaving(false);
    }, 300);
    sessionStorage.setItem('mtd_banner_dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#FFD700] text-black px-4 py-3 shadow-[0_-4px_15px_rgba(0,0,0,0.4)] transition-transform duration-300 ease-in-out ${isLeaving ? 'translate-y-full' : 'translate-y-0'
        }`}
    >
      <div className="flex items-center justify-between gap-4 max-w-md mx-auto">
        <div className="flex-1 min-w-0">
          <p className="text-[14px] font-bold leading-none">
            MTD 2026 is LIVE <span className="text-base leading-none translate-y-[-1px] inline-block ml-1">🚨</span>
          </p>
        </div>

        <div className="flex items-center gap-1.5 shrink-0">
          <a
            href="/mtd-2026-guide#mandation"
            className="bg-black text-white text-[10px] font-black uppercase tracking-widest px-3 py-2.5 rounded shadow-lg hover:bg-slate-900 active:scale-95 transition-all whitespace-nowrap"
          >
            Check My Status
          </a>

          <button
            onClick={handleDismiss}
            className="p-1 opacity-40 hover:opacity-100 transition-opacity"
            aria-label="Dismiss"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
